/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AdminCompleteMatchBody,
  AdminCompleteMatchResponse,
  ApiError,
  ApproveTeamResponse,
  ConfirmResultResponse,
  CreateLeagueBody,
  CreateLeagueResponse,
  DeleteLeagueResponse,
  DisputeResultBody,
  DisputeResultResponse,
  GenerateFixturesResponse,
  GeneratePlayoffsResponse,
  GetLeagueMatchResponse,
  GetLeagueResponse,
  GetLeagueScheduleResponse,
  GetLeagueStandingsResponse,
  GetLeagueTeamsResponse,
  GetLeaguesResponse,
  LeagueStatus,
  LeagueTeamStatus,
  RegisterLeagueTeamBody,
  RegisterTeamResponse,
  SubmitResultBody,
  SubmitResultResponse,
  UpdateLeagueBody,
  UpdateLeagueResponse,
} from '../models/index';
import {
    AdminCompleteMatchBodyFromJSON,
    AdminCompleteMatchBodyToJSON,
    AdminCompleteMatchResponseFromJSON,
    AdminCompleteMatchResponseToJSON,
    ApiErrorFromJSON,
    ApiErrorToJSON,
    ApproveTeamResponseFromJSON,
    ApproveTeamResponseToJSON,
    ConfirmResultResponseFromJSON,
    ConfirmResultResponseToJSON,
    CreateLeagueBodyFromJSON,
    CreateLeagueBodyToJSON,
    CreateLeagueResponseFromJSON,
    CreateLeagueResponseToJSON,
    DeleteLeagueResponseFromJSON,
    DeleteLeagueResponseToJSON,
    DisputeResultBodyFromJSON,
    DisputeResultBodyToJSON,
    DisputeResultResponseFromJSON,
    DisputeResultResponseToJSON,
    GenerateFixturesResponseFromJSON,
    GenerateFixturesResponseToJSON,
    GeneratePlayoffsResponseFromJSON,
    GeneratePlayoffsResponseToJSON,
    GetLeagueMatchResponseFromJSON,
    GetLeagueMatchResponseToJSON,
    GetLeagueResponseFromJSON,
    GetLeagueResponseToJSON,
    GetLeagueScheduleResponseFromJSON,
    GetLeagueScheduleResponseToJSON,
    GetLeagueStandingsResponseFromJSON,
    GetLeagueStandingsResponseToJSON,
    GetLeagueTeamsResponseFromJSON,
    GetLeagueTeamsResponseToJSON,
    GetLeaguesResponseFromJSON,
    GetLeaguesResponseToJSON,
    LeagueStatusFromJSON,
    LeagueStatusToJSON,
    LeagueTeamStatusFromJSON,
    LeagueTeamStatusToJSON,
    RegisterLeagueTeamBodyFromJSON,
    RegisterLeagueTeamBodyToJSON,
    RegisterTeamResponseFromJSON,
    RegisterTeamResponseToJSON,
    SubmitResultBodyFromJSON,
    SubmitResultBodyToJSON,
    SubmitResultResponseFromJSON,
    SubmitResultResponseToJSON,
    UpdateLeagueBodyFromJSON,
    UpdateLeagueBodyToJSON,
    UpdateLeagueResponseFromJSON,
    UpdateLeagueResponseToJSON,
} from '../models/index';

export interface CreateLeaguesRequest {
    createLeagueBody: CreateLeagueBody;
}

export interface CreateLeaguesIdFixturesGenerateRequest {
    id: string;
    body?: object;
}

export interface CreateLeaguesIdMatchesMatchIdDisputeRequest {
    id: string;
    matchId: string;
    disputeResultBody: DisputeResultBody;
}

export interface CreateLeaguesIdMatchesMatchIdSubmitResultRequest {
    id: string;
    matchId: string;
    submitResultBody: SubmitResultBody;
}

export interface CreateLeaguesIdPlayoffsGenerateRequest {
    id: string;
    body?: object;
}

export interface CreateLeaguesIdRegisterRequest {
    id: string;
    registerLeagueTeamBody: RegisterLeagueTeamBody;
}

export interface CreateLeaguesIdTeamsTeamIdApproveRequest {
    id: string;
    teamId: string;
    body?: object;
}

export interface DeleteLeaguesIdRequest {
    id: string;
}

export interface GetLeaguesRequest {
    status?: Array<LeagueStatus>;
    gameId?: string;
    search?: string;
    limit?: number;
    offset?: number;
}

export interface GetLeaguesIdRequest {
    id: string;
}

export interface GetLeaguesIdMatchesMatchIdRequest {
    id: string;
    matchId: string;
}

export interface GetLeaguesIdScheduleRequest {
    id: string;
}

export interface GetLeaguesIdStandingsRequest {
    id: string;
}

export interface GetLeaguesIdTeamsRequest {
    id: string;
    limit?: number;
    offset?: number;
    status?: LeagueTeamStatus;
}

export interface UpdateLeaguesIdRequest {
    id: string;
    updateLeagueBody: UpdateLeagueBody;
}

export interface UpdateLeaguesIdMatchesMatchIdAdminCompleteRequest {
    id: string;
    matchId: string;
    adminCompleteMatchBody: AdminCompleteMatchBody;
}

export interface UpdateLeaguesIdMatchesMatchIdConfirmRequest {
    id: string;
    matchId: string;
    body?: object;
}

/**
 * LeaguesApi - interface
 * 
 * @export
 * @interface LeaguesApiInterface
 */
export interface LeaguesApiInterface {
    /**
     * 
     * @param {CreateLeagueBody} createLeagueBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeaguesApiInterface
     */
    createLeaguesRaw(requestParameters: CreateLeaguesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateLeagueResponse>>;

    /**
     */
    createLeagues(requestParameters: CreateLeaguesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateLeagueResponse>;

    /**
     * 
     * @param {string} id 
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeaguesApiInterface
     */
    createLeaguesIdFixturesGenerateRaw(requestParameters: CreateLeaguesIdFixturesGenerateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GenerateFixturesResponse>>;

    /**
     */
    createLeaguesIdFixturesGenerate(requestParameters: CreateLeaguesIdFixturesGenerateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GenerateFixturesResponse>;

    /**
     * 
     * @param {string} id League ID
     * @param {string} matchId Match ID
     * @param {DisputeResultBody} disputeResultBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeaguesApiInterface
     */
    createLeaguesIdMatchesMatchIdDisputeRaw(requestParameters: CreateLeaguesIdMatchesMatchIdDisputeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DisputeResultResponse>>;

    /**
     */
    createLeaguesIdMatchesMatchIdDispute(requestParameters: CreateLeaguesIdMatchesMatchIdDisputeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DisputeResultResponse>;

    /**
     * 
     * @param {string} id League ID
     * @param {string} matchId Match ID
     * @param {SubmitResultBody} submitResultBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeaguesApiInterface
     */
    createLeaguesIdMatchesMatchIdSubmitResultRaw(requestParameters: CreateLeaguesIdMatchesMatchIdSubmitResultRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubmitResultResponse>>;

    /**
     */
    createLeaguesIdMatchesMatchIdSubmitResult(requestParameters: CreateLeaguesIdMatchesMatchIdSubmitResultRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubmitResultResponse>;

    /**
     * Creates a playoff bracket using the top teams from the league standings. Requires all regular season matches to be completed and playoffs to be enabled in the league configuration. 
     * @summary Generate playoff bracket from league standings
     * @param {string} id 
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeaguesApiInterface
     */
    createLeaguesIdPlayoffsGenerateRaw(requestParameters: CreateLeaguesIdPlayoffsGenerateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GeneratePlayoffsResponse>>;

    /**
     * Creates a playoff bracket using the top teams from the league standings. Requires all regular season matches to be completed and playoffs to be enabled in the league configuration. 
     * Generate playoff bracket from league standings
     */
    createLeaguesIdPlayoffsGenerate(requestParameters: CreateLeaguesIdPlayoffsGenerateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GeneratePlayoffsResponse>;

    /**
     * 
     * @param {string} id 
     * @param {RegisterLeagueTeamBody} registerLeagueTeamBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeaguesApiInterface
     */
    createLeaguesIdRegisterRaw(requestParameters: CreateLeaguesIdRegisterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RegisterTeamResponse>>;

    /**
     */
    createLeaguesIdRegister(requestParameters: CreateLeaguesIdRegisterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RegisterTeamResponse>;

    /**
     * 
     * @param {string} id League ID
     * @param {string} teamId Team ID to approve
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeaguesApiInterface
     */
    createLeaguesIdTeamsTeamIdApproveRaw(requestParameters: CreateLeaguesIdTeamsTeamIdApproveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApproveTeamResponse>>;

    /**
     */
    createLeaguesIdTeamsTeamIdApprove(requestParameters: CreateLeaguesIdTeamsTeamIdApproveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApproveTeamResponse>;

    /**
     * Soft deletes a league by setting status to ARCHIVED. Cannot delete active leagues.
     * @summary Delete (archive) a league
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeaguesApiInterface
     */
    deleteLeaguesIdRaw(requestParameters: DeleteLeaguesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteLeagueResponse>>;

    /**
     * Soft deletes a league by setting status to ARCHIVED. Cannot delete active leagues.
     * Delete (archive) a league
     */
    deleteLeaguesId(requestParameters: DeleteLeaguesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteLeagueResponse>;

    /**
     * 
     * @param {Array<LeagueStatus>} [status] Filter by status (single value or repeated for multiple, e.g. ?status&#x3D;ACTIVE&amp;status&#x3D;REGISTRATION)
     * @param {string} [gameId] 
     * @param {string} [search] Search by league name or description
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeaguesApiInterface
     */
    getLeaguesRaw(requestParameters: GetLeaguesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLeaguesResponse>>;

    /**
     */
    getLeagues(requestParameters: GetLeaguesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLeaguesResponse>;

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeaguesApiInterface
     */
    getLeaguesIdRaw(requestParameters: GetLeaguesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLeagueResponse>>;

    /**
     */
    getLeaguesId(requestParameters: GetLeaguesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLeagueResponse>;

    /**
     * 
     * @param {string} id League ID
     * @param {string} matchId Match ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeaguesApiInterface
     */
    getLeaguesIdMatchesMatchIdRaw(requestParameters: GetLeaguesIdMatchesMatchIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLeagueMatchResponse>>;

    /**
     */
    getLeaguesIdMatchesMatchId(requestParameters: GetLeaguesIdMatchesMatchIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLeagueMatchResponse>;

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeaguesApiInterface
     */
    getLeaguesIdScheduleRaw(requestParameters: GetLeaguesIdScheduleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLeagueScheduleResponse>>;

    /**
     */
    getLeaguesIdSchedule(requestParameters: GetLeaguesIdScheduleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLeagueScheduleResponse>;

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeaguesApiInterface
     */
    getLeaguesIdStandingsRaw(requestParameters: GetLeaguesIdStandingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLeagueStandingsResponse>>;

    /**
     */
    getLeaguesIdStandings(requestParameters: GetLeaguesIdStandingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLeagueStandingsResponse>;

    /**
     * 
     * @param {string} id 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {LeagueTeamStatus} [status] Filter by team status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeaguesApiInterface
     */
    getLeaguesIdTeamsRaw(requestParameters: GetLeaguesIdTeamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLeagueTeamsResponse>>;

    /**
     */
    getLeaguesIdTeams(requestParameters: GetLeaguesIdTeamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLeagueTeamsResponse>;

    /**
     * 
     * @param {string} id 
     * @param {UpdateLeagueBody} updateLeagueBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeaguesApiInterface
     */
    updateLeaguesIdRaw(requestParameters: UpdateLeaguesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateLeagueResponse>>;

    /**
     */
    updateLeaguesId(requestParameters: UpdateLeaguesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateLeagueResponse>;

    /**
     * 
     * @param {string} id League ID
     * @param {string} matchId Match ID within the league
     * @param {AdminCompleteMatchBody} adminCompleteMatchBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeaguesApiInterface
     */
    updateLeaguesIdMatchesMatchIdAdminCompleteRaw(requestParameters: UpdateLeaguesIdMatchesMatchIdAdminCompleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminCompleteMatchResponse>>;

    /**
     */
    updateLeaguesIdMatchesMatchIdAdminComplete(requestParameters: UpdateLeaguesIdMatchesMatchIdAdminCompleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminCompleteMatchResponse>;

    /**
     * 
     * @param {string} id League ID
     * @param {string} matchId Match ID
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeaguesApiInterface
     */
    updateLeaguesIdMatchesMatchIdConfirmRaw(requestParameters: UpdateLeaguesIdMatchesMatchIdConfirmRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConfirmResultResponse>>;

    /**
     */
    updateLeaguesIdMatchesMatchIdConfirm(requestParameters: UpdateLeaguesIdMatchesMatchIdConfirmRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConfirmResultResponse>;

}

/**
 * 
 */
export class LeaguesApi extends runtime.BaseAPI implements LeaguesApiInterface {

    /**
     */
    async createLeaguesRaw(requestParameters: CreateLeaguesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateLeagueResponse>> {
        if (requestParameters['createLeagueBody'] == null) {
            throw new runtime.RequiredError(
                'createLeagueBody',
                'Required parameter "createLeagueBody" was null or undefined when calling createLeagues().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/leagues`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateLeagueBodyToJSON(requestParameters['createLeagueBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateLeagueResponseFromJSON(jsonValue));
    }

    /**
     */
    async createLeagues(requestParameters: CreateLeaguesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateLeagueResponse> {
        const response = await this.createLeaguesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createLeaguesIdFixturesGenerateRaw(requestParameters: CreateLeaguesIdFixturesGenerateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GenerateFixturesResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createLeaguesIdFixturesGenerate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/leagues/{id}/fixtures/generate`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GenerateFixturesResponseFromJSON(jsonValue));
    }

    /**
     */
    async createLeaguesIdFixturesGenerate(requestParameters: CreateLeaguesIdFixturesGenerateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GenerateFixturesResponse> {
        const response = await this.createLeaguesIdFixturesGenerateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createLeaguesIdMatchesMatchIdDisputeRaw(requestParameters: CreateLeaguesIdMatchesMatchIdDisputeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DisputeResultResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createLeaguesIdMatchesMatchIdDispute().'
            );
        }

        if (requestParameters['matchId'] == null) {
            throw new runtime.RequiredError(
                'matchId',
                'Required parameter "matchId" was null or undefined when calling createLeaguesIdMatchesMatchIdDispute().'
            );
        }

        if (requestParameters['disputeResultBody'] == null) {
            throw new runtime.RequiredError(
                'disputeResultBody',
                'Required parameter "disputeResultBody" was null or undefined when calling createLeaguesIdMatchesMatchIdDispute().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/leagues/{id}/matches/{matchId}/dispute`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace(`{${"matchId"}}`, encodeURIComponent(String(requestParameters['matchId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DisputeResultBodyToJSON(requestParameters['disputeResultBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DisputeResultResponseFromJSON(jsonValue));
    }

    /**
     */
    async createLeaguesIdMatchesMatchIdDispute(requestParameters: CreateLeaguesIdMatchesMatchIdDisputeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DisputeResultResponse> {
        const response = await this.createLeaguesIdMatchesMatchIdDisputeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createLeaguesIdMatchesMatchIdSubmitResultRaw(requestParameters: CreateLeaguesIdMatchesMatchIdSubmitResultRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubmitResultResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createLeaguesIdMatchesMatchIdSubmitResult().'
            );
        }

        if (requestParameters['matchId'] == null) {
            throw new runtime.RequiredError(
                'matchId',
                'Required parameter "matchId" was null or undefined when calling createLeaguesIdMatchesMatchIdSubmitResult().'
            );
        }

        if (requestParameters['submitResultBody'] == null) {
            throw new runtime.RequiredError(
                'submitResultBody',
                'Required parameter "submitResultBody" was null or undefined when calling createLeaguesIdMatchesMatchIdSubmitResult().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/leagues/{id}/matches/{matchId}/submit-result`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace(`{${"matchId"}}`, encodeURIComponent(String(requestParameters['matchId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SubmitResultBodyToJSON(requestParameters['submitResultBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubmitResultResponseFromJSON(jsonValue));
    }

    /**
     */
    async createLeaguesIdMatchesMatchIdSubmitResult(requestParameters: CreateLeaguesIdMatchesMatchIdSubmitResultRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubmitResultResponse> {
        const response = await this.createLeaguesIdMatchesMatchIdSubmitResultRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a playoff bracket using the top teams from the league standings. Requires all regular season matches to be completed and playoffs to be enabled in the league configuration. 
     * Generate playoff bracket from league standings
     */
    async createLeaguesIdPlayoffsGenerateRaw(requestParameters: CreateLeaguesIdPlayoffsGenerateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GeneratePlayoffsResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createLeaguesIdPlayoffsGenerate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/leagues/{id}/playoffs/generate`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GeneratePlayoffsResponseFromJSON(jsonValue));
    }

    /**
     * Creates a playoff bracket using the top teams from the league standings. Requires all regular season matches to be completed and playoffs to be enabled in the league configuration. 
     * Generate playoff bracket from league standings
     */
    async createLeaguesIdPlayoffsGenerate(requestParameters: CreateLeaguesIdPlayoffsGenerateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GeneratePlayoffsResponse> {
        const response = await this.createLeaguesIdPlayoffsGenerateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createLeaguesIdRegisterRaw(requestParameters: CreateLeaguesIdRegisterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RegisterTeamResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createLeaguesIdRegister().'
            );
        }

        if (requestParameters['registerLeagueTeamBody'] == null) {
            throw new runtime.RequiredError(
                'registerLeagueTeamBody',
                'Required parameter "registerLeagueTeamBody" was null or undefined when calling createLeaguesIdRegister().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/leagues/{id}/register`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RegisterLeagueTeamBodyToJSON(requestParameters['registerLeagueTeamBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RegisterTeamResponseFromJSON(jsonValue));
    }

    /**
     */
    async createLeaguesIdRegister(requestParameters: CreateLeaguesIdRegisterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RegisterTeamResponse> {
        const response = await this.createLeaguesIdRegisterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createLeaguesIdTeamsTeamIdApproveRaw(requestParameters: CreateLeaguesIdTeamsTeamIdApproveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApproveTeamResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createLeaguesIdTeamsTeamIdApprove().'
            );
        }

        if (requestParameters['teamId'] == null) {
            throw new runtime.RequiredError(
                'teamId',
                'Required parameter "teamId" was null or undefined when calling createLeaguesIdTeamsTeamIdApprove().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/leagues/{id}/teams/{teamId}/approve`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace(`{${"teamId"}}`, encodeURIComponent(String(requestParameters['teamId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApproveTeamResponseFromJSON(jsonValue));
    }

    /**
     */
    async createLeaguesIdTeamsTeamIdApprove(requestParameters: CreateLeaguesIdTeamsTeamIdApproveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApproveTeamResponse> {
        const response = await this.createLeaguesIdTeamsTeamIdApproveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Soft deletes a league by setting status to ARCHIVED. Cannot delete active leagues.
     * Delete (archive) a league
     */
    async deleteLeaguesIdRaw(requestParameters: DeleteLeaguesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteLeagueResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteLeaguesId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/leagues/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteLeagueResponseFromJSON(jsonValue));
    }

    /**
     * Soft deletes a league by setting status to ARCHIVED. Cannot delete active leagues.
     * Delete (archive) a league
     */
    async deleteLeaguesId(requestParameters: DeleteLeaguesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteLeagueResponse> {
        const response = await this.deleteLeaguesIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getLeaguesRaw(requestParameters: GetLeaguesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLeaguesResponse>> {
        const queryParameters: any = {};

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['gameId'] != null) {
            queryParameters['gameId'] = requestParameters['gameId'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/leagues`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLeaguesResponseFromJSON(jsonValue));
    }

    /**
     */
    async getLeagues(requestParameters: GetLeaguesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLeaguesResponse> {
        const response = await this.getLeaguesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getLeaguesIdRaw(requestParameters: GetLeaguesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLeagueResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getLeaguesId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/leagues/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLeagueResponseFromJSON(jsonValue));
    }

    /**
     */
    async getLeaguesId(requestParameters: GetLeaguesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLeagueResponse> {
        const response = await this.getLeaguesIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getLeaguesIdMatchesMatchIdRaw(requestParameters: GetLeaguesIdMatchesMatchIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLeagueMatchResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getLeaguesIdMatchesMatchId().'
            );
        }

        if (requestParameters['matchId'] == null) {
            throw new runtime.RequiredError(
                'matchId',
                'Required parameter "matchId" was null or undefined when calling getLeaguesIdMatchesMatchId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/leagues/{id}/matches/{matchId}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace(`{${"matchId"}}`, encodeURIComponent(String(requestParameters['matchId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLeagueMatchResponseFromJSON(jsonValue));
    }

    /**
     */
    async getLeaguesIdMatchesMatchId(requestParameters: GetLeaguesIdMatchesMatchIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLeagueMatchResponse> {
        const response = await this.getLeaguesIdMatchesMatchIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getLeaguesIdScheduleRaw(requestParameters: GetLeaguesIdScheduleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLeagueScheduleResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getLeaguesIdSchedule().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/leagues/{id}/schedule`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLeagueScheduleResponseFromJSON(jsonValue));
    }

    /**
     */
    async getLeaguesIdSchedule(requestParameters: GetLeaguesIdScheduleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLeagueScheduleResponse> {
        const response = await this.getLeaguesIdScheduleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getLeaguesIdStandingsRaw(requestParameters: GetLeaguesIdStandingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLeagueStandingsResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getLeaguesIdStandings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/leagues/{id}/standings`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLeagueStandingsResponseFromJSON(jsonValue));
    }

    /**
     */
    async getLeaguesIdStandings(requestParameters: GetLeaguesIdStandingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLeagueStandingsResponse> {
        const response = await this.getLeaguesIdStandingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getLeaguesIdTeamsRaw(requestParameters: GetLeaguesIdTeamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLeagueTeamsResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getLeaguesIdTeams().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/leagues/{id}/teams`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLeagueTeamsResponseFromJSON(jsonValue));
    }

    /**
     */
    async getLeaguesIdTeams(requestParameters: GetLeaguesIdTeamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLeagueTeamsResponse> {
        const response = await this.getLeaguesIdTeamsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateLeaguesIdRaw(requestParameters: UpdateLeaguesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateLeagueResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateLeaguesId().'
            );
        }

        if (requestParameters['updateLeagueBody'] == null) {
            throw new runtime.RequiredError(
                'updateLeagueBody',
                'Required parameter "updateLeagueBody" was null or undefined when calling updateLeaguesId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/leagues/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateLeagueBodyToJSON(requestParameters['updateLeagueBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateLeagueResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateLeaguesId(requestParameters: UpdateLeaguesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateLeagueResponse> {
        const response = await this.updateLeaguesIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateLeaguesIdMatchesMatchIdAdminCompleteRaw(requestParameters: UpdateLeaguesIdMatchesMatchIdAdminCompleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminCompleteMatchResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateLeaguesIdMatchesMatchIdAdminComplete().'
            );
        }

        if (requestParameters['matchId'] == null) {
            throw new runtime.RequiredError(
                'matchId',
                'Required parameter "matchId" was null or undefined when calling updateLeaguesIdMatchesMatchIdAdminComplete().'
            );
        }

        if (requestParameters['adminCompleteMatchBody'] == null) {
            throw new runtime.RequiredError(
                'adminCompleteMatchBody',
                'Required parameter "adminCompleteMatchBody" was null or undefined when calling updateLeaguesIdMatchesMatchIdAdminComplete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/leagues/{id}/matches/{matchId}/admin-complete`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace(`{${"matchId"}}`, encodeURIComponent(String(requestParameters['matchId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AdminCompleteMatchBodyToJSON(requestParameters['adminCompleteMatchBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminCompleteMatchResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateLeaguesIdMatchesMatchIdAdminComplete(requestParameters: UpdateLeaguesIdMatchesMatchIdAdminCompleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminCompleteMatchResponse> {
        const response = await this.updateLeaguesIdMatchesMatchIdAdminCompleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateLeaguesIdMatchesMatchIdConfirmRaw(requestParameters: UpdateLeaguesIdMatchesMatchIdConfirmRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConfirmResultResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateLeaguesIdMatchesMatchIdConfirm().'
            );
        }

        if (requestParameters['matchId'] == null) {
            throw new runtime.RequiredError(
                'matchId',
                'Required parameter "matchId" was null or undefined when calling updateLeaguesIdMatchesMatchIdConfirm().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/leagues/{id}/matches/{matchId}/confirm`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace(`{${"matchId"}}`, encodeURIComponent(String(requestParameters['matchId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConfirmResultResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateLeaguesIdMatchesMatchIdConfirm(requestParameters: UpdateLeaguesIdMatchesMatchIdConfirmRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConfirmResultResponse> {
        const response = await this.updateLeaguesIdMatchesMatchIdConfirmRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
